// |--------------------------------------------------------------------------
// |ユーザー情報
// ログイン認証時に取得したユーザー情報を格納します

// vue側で呼び出す場合は import 任意の変数名 from "@/stubs/〇〇.js";と記載します
// 例：demo.id

// オブジェクトの中身を変数に格納する場合は「...test」とする
// 例：const test = {...test};
// |--------------------------------------------------------------------------

/* ---------------------------------------------------------------------------
パスワード
---------------------------------------------------------------------------- */
export const forgot = {
	email: ""
};

export const resetData = {
	token: "",
	email: "",
	password: ""
};
